import classNames from 'classnames';

import { MinusIcon, PlusIcon } from '../../icons';

import styles from './_index.module.scss';

export interface MinusPlusButtonsProps {
  disableMinusButton?: boolean;
  disablePlusButton?: boolean;
  hasMinusButton?: boolean;
  hasPlusButton?: boolean;
  isNeutral?: boolean;
  minusAriaLabel?: string;
  onClickMinus?: () => void;
  onClickPlus?: () => void;
  plusAriaLabel?: string;
}

const MinusPlusButtons = ({
  disableMinusButton,
  disablePlusButton,
  hasMinusButton = true,
  hasPlusButton = true,
  isNeutral,
  minusAriaLabel = 'Remove',
  onClickMinus,
  onClickPlus,
  plusAriaLabel = 'Add',
}: MinusPlusButtonsProps) => {
  return (
    <span className={styles['minus-plus-buttons']}>
      {hasMinusButton && (
        <button
          aria-label={minusAriaLabel}
          className={classNames(styles['button-minus-icon'], { [styles['is-neutral']]: isNeutral })}
          data-testid="button-minus-icon"
          disabled={disableMinusButton}
          onClick={onClickMinus}
          type="button"
        >
          <MinusIcon />
        </button>
      )}
      {hasPlusButton && (
        <button
          aria-label={plusAriaLabel}
          className={classNames(styles['button-plus-icon'], { [styles['is-neutral']]: isNeutral })}
          data-testid="button-plus-icon"
          disabled={disablePlusButton}
          onClick={onClickPlus}
          type="button"
        >
          <PlusIcon />
        </button>
      )}
    </span>
  );
};

export default MinusPlusButtons;
